// @flow
import React, { Component } from 'react';
import type { ProductSequence } from 'store/modules/products';
import { connect } from 'react-redux';
import type { State } from 'store';

import ProductSequences from 'components/product/ProductSequences/ProductSequences';

type Props = {
  sequences: ?(ProductSequence[]),
  username: string,
  supplier: string,
  displayName: string,
  currentProductId: string,
};

class ProductSequencesContainer extends Component<Props> {
  render() {
    const { sequences, username, supplier, displayName, currentProductId } = this.props;

    return (
      <ProductSequences
        sequences={sequences}
        username={username}
        supplier={supplier}
        displayName={displayName}
        currentProductId={currentProductId}
      />
    );
  }
}

export default connect(
  ({ products }: State) => ({
    sequences: products.sequences,
    displayName: products.product && products.product.user.display_name,
    currentProductId: products.product && products.product.id,
  }),
  () => ({}),
)(ProductSequencesContainer);



// WEBPACK FOOTER //
// ./src/containers/product/ProductSequencesContainer.js